import React, { PropTypes } from 'react'
import Toggle from 'material-ui/Toggle'

const styles = {
  label: {
    textAlign: 'right'
  },
  toggle: {
    backgroundColor: '#252CAB'
  },
  toggleBackground: {
    backgroundColor: 'rgba(37, 44, 171, 0.5)'
  }
}

const ToggleStats = ({ label, value, onChange }) => {
  const handleToggle = () => {
    onChange()
  }

  return (
    <Toggle
      toggled={value}
      label={label}
      labelPosition='left'
      labelStyle={styles.label}
// @ts-ignore
      iconStyle={styles.ripple}
      thumbSwitchedStyle={styles.toggle}
      trackSwitchedStyle={styles.toggleBackground}
      onToggle={handleToggle}
    />
  )
}

// @ts-ignore
ToggleStats.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default ToggleStats
